/* Thighrise product cards (snippets/tr-card.liquid), operator 07-10:
   - colour dot click shows that colour's photo on the card and links to that colour;
   - bag "+" opens a size row on the photo; a size click adds to cart via /cart/add.js
     (20-10: without opening the Essential Cart Drawer, see added()). */
(function () {
  function T(k, f) { return (window.SB_T && window.SB_T[k]) || f; }   // multilingual 14-10 (snippets/sb-i18n.liquid)
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function card(el) { return el.closest('[data-tr-card]'); }
  // 20-10 (code review #17): a missing or broken variant list gives an empty list, not a dead card.
  function variants(c) { if (!c._v) { try { c._v = JSON.parse(c.querySelector('[data-tr-card-v]').textContent); } catch (e) { c._v = []; } } return c._v; }
  function color(c) { var a = c.querySelector('.tr-sw.is-active'); return a ? a.dataset.trSw : null; }
  function link(c) {
    var col = color(c), v = variants(c).find(function (x) { return col === null || x[1] === col; });
    c.querySelectorAll('[data-tr-card-link]').forEach(function (a) { a.href = c.dataset.url + (v && col !== null ? '?variant=' + v[0] : ''); });
  }
  function sizes(c, qa) {
    var col = color(c), list = variants(c).filter(function (x) { return col === null || x[1] === col; });
    if (list.length === 1 && list[0][2] === null) return add(c, qa, list[0][0]);
    // 20-10 (review #1): more variants but no size (the belt: width + length) cannot be picked on a card; the product page can.
    if (list.some(function (x) { return x[2] === null; })) { location.href = c.querySelector('[data-tr-card-link]').href; return; }
    qa.innerHTML = '<button type="button" class="tr-qa__x" aria-label="' + T('close', 'Close') + '">&times;</button><p>' + T('select_size', 'Select a size') + '</p><div class="tr-qa__s"></div>';
    if (col !== null) qa.querySelector('p').textContent = T('select_size', 'Select a size') + ' – ' + (window.SBV ? SBV(col) : col); // which colour "+" adds (default = first dot)
    var row = qa.querySelector('.tr-qa__s');
    list.forEach(function (x) {
      var b = document.createElement('button');
      b.type = 'button'; b.textContent = x[2]; b.disabled = !x[3]; b.dataset.id = x[0];
      row.appendChild(b);
    });
    qa.hidden = false;
  }
  // Klaviyo "Added to Cart" for quick adds (review 07-10 M5): the PDP tracker in snippets/klaviyo-tracking.liquid only sees the product form.
  function klAdd(i) {
    try {
      var k = window.klaviyo || (window._klOnsite = window._klOnsite || []);
      k.push(['track', 'Added to Cart', { $value: i.final_line_price / 100, ProductName: i.product_title, ProductID: i.product_id, VariantID: i.variant_id,
        Quantity: i.quantity, Price: i.final_price / 100, ImageURL: i.image, URL: location.origin + i.url }]);
    } catch (e) {}
  }
  // Operator 20-10 (option B): a card add keeps the shopper on the grid. "?partial=true" is a URL the Essential drawer's
  // fetch hook skips, so it does not slide open; refreshCart() then updates its count and contents while closed.
  // Instead: an "Added to bag" band on the card and the photo flying into the bag icon.
  var EASE = 'cubic-bezier(.22,1,.36,1)';
  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  var still = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function bump(icon) { if (icon && !still) icon.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.25)' }, { transform: 'scale(1)' }], { duration: 450, easing: EASE }); }
  function added(c) {
    var m = c.querySelector('.tr-card__media'), ok = document.createElement('div');
    ok.className = 'tr-card__ok'; ok.setAttribute('role', 'status');
    ok.innerHTML = CHECK + '<span>' + T('added', 'Added to bag') + '</span>';
    m.appendChild(ok);
    if (!still) ok.animate([{ transform: 'translateY(100%)' }, { transform: 'none' }], { duration: 320, easing: EASE });
    setTimeout(function () { ok.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 250, fill: 'forwards' }).onfinish = function () { ok.remove(); }; }, 1600);
    var img = m.querySelector('img'), icon = document.querySelector('[data-tr-cart]');
    if (still || !img || !icon) return bump(icon);
    var a = img.getBoundingClientRect(), b = icon.getBoundingClientRect(), s = 64, f = document.createElement('div');
    f.className = 'tr-fly';
    f.style.cssText = 'left:' + (a.left + a.width / 2 - s / 2) + 'px;top:' + (a.top + a.height / 2 - s / 2) + 'px;background-image:url("' + (img.currentSrc || img.src) + '")';
    document.body.appendChild(f);
    var dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
    f.animate([
      { transform: 'none' },
      { transform: 'translate(' + dx * .35 + 'px,' + (dy * .35 - 40) + 'px) scale(.8)', offset: .4 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.2)', opacity: .6 }
    ], { duration: 700, easing: 'cubic-bezier(.5,0,.75,0)' }).onfinish = function () { f.remove(); bump(icon); };
  }
  function add(c, qa, id, btn) {
    if (c.dataset.trBusy) return;   // a double tap adds once, also via "+" on one-size products (review 09-10 #7)
    c.dataset.trBusy = '1';
    if (btn) btn.classList.add('is-busy');
    fetch(ROOT + 'cart/add.js?partial=true', { method: 'POST', headers: { 'content-type': 'application/json', accept: 'application/json' }, body: JSON.stringify({ id: +id, quantity: 1 }) })
      .then(function (r) { if (!r.ok) throw new Error(r.status); qa.hidden = true; return r.json(); })
      .then(function (i) {
        added(c);
        if (window.essentialCartApi) essentialCartApi.refreshCart();
        klAdd(i);
      })
      .catch(function () { location.href = c.querySelector('[data-tr-card-link]').href; })
      .finally(function () { delete c.dataset.trBusy; if (btn) btn.classList.remove('is-busy'); });
  }
  // Swatch dots are a zoomed crop of the variant photo (~15 KB each, up to 5 per card): load them only when the card
  // gets near the viewport instead of all at once (review 07-10 speed).
  function paint(el) { el.style.backgroundImage = "url('" + el.dataset.bg + "')"; el.removeAttribute('data-bg'); }
  function lazyDots() {
    var dots = document.querySelectorAll('.tr-sw[data-bg]');
    if (!('IntersectionObserver' in window)) { dots.forEach(paint); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (x) { if (x.isIntersecting) { io.unobserve(x.target); paint(x.target); } }); }, { rootMargin: '400px' });
    dots.forEach(function (d) { io.observe(d); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', lazyDots); else lazyDots();
  document.addEventListener('click', function (e) {
    var t = e.target, c = card(t);
    if (!c) return;
    var sw = t.closest('[data-tr-sw]');
    if (sw) {
      e.preventDefault();
      c.querySelectorAll('[data-tr-sw]').forEach(function (x) { x.classList.toggle('is-active', x === sw); });
      var img = c.querySelector('.tr-card__media img');
      if (img && sw.dataset.src) { img.srcset = sw.dataset.srcset; img.src = sw.dataset.src; c.classList.add('is-picked'); }
      link(c);
      var qa = c.querySelector('[data-tr-card-qa]');
      if (qa && !qa.hidden) sizes(c, qa);
      return;
    }
    if (t.closest('[data-tr-card-add]')) { e.preventDefault(); sizes(c, c.querySelector('[data-tr-card-qa]')); return; }
    var qa = t.closest('[data-tr-card-qa]');
    if (qa) {
      e.preventDefault();
      if (t.closest('.tr-qa__x')) { qa.hidden = true; return; }
      var b = t.closest('.tr-qa__s button');
      if (b && !b.disabled) add(c, qa, b.dataset.id, b);
    }
  });
})();
